import { Component, OnInit } from "@angular/core";
import { StatusListener }    from "../../../status-listener";
import { AppService }        from "../../../services/app.service";

@Component({
	selector: "app-tur-maintenance",
	templateUrl: "./tur-maintenance.component.html",
	styleUrls: ["./tur-maintenance.component.scss"]
})
export class TurMaintenanceComponent extends StatusListener implements OnInit {

	currentTab: string = "config";

	constructor(app: AppService) {
		super(app);
	}

	setTab(nextTab) {
		this.currentTab = nextTab;
	}
}
